import { AxiosResponse } from 'axios';
import { alertList, alertUpdate } from '@/api/alert';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IAlertApiListResponse, IAlertFilters, IAlertUpdateParams } from '@/types/alert';

export const alertService = {
    async list(params: IListParams<IAlertFilters>): Promise<AxiosResponse<IAlertApiListResponse>> {
        try {
            const response = await baseListService<IAlertApiListResponse>(alertList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Alert API Error:', e);
            throw new AppError('Unable to load alert list, request error', { cause: e });
        }
    },

    async update(params: IAlertUpdateParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await alertUpdate(params);
        } catch (e) {
            console.error('Alert Update API Error:', e);
            throw new AppError('Unable to update alert, request error', { cause: e });
        }
    },
};
